import { InputLabel, TextField, Typography } from "@mui/material"
import { red } from "@mui/material/colors"
import { Fragment } from "react"
import { uid } from "uid"

function InputField1({ id, label, type, errors, name, placeholder, errText, onChangeFun, rows, endIcon, slotProps, ...rest }) {
  id = id || uid(6)

  return (
    <Fragment>
      {label &&
        <InputLabel
          htmlFor={id}
          variant="specialistSignup"
        >{label}
        </InputLabel>
      }
      <TextField
        hiddenLabel
        size="small"
        id={id || null}
        rows={rows || 4}
        variant="filled"
        name={name || null}
        autoComplete="true"
        type={type || "text"}
        placeholder={placeholder}
        varianttype="specialistSignup"
        multiline={type === "textarea"}
        onChange={onChangeFun || null}
        slotProps={{
          input: {
            autoComplete: "new-password",
            endAdornment: endIcon || null,
            ...slotProps
          },
        }}
        {...rest}
      />
      {errors?.[name] &&
        <Typography
          mt={1}
          color={red["500"]}
        >{errText}
        </Typography>
      }
    </Fragment>
  )
}

export default InputField1